import { GcpCollectionModel, GcpModel } from '../../../../../../typings/api/skymap/rest/v0/.common';
import { isDefined } from '../../../../utils/variables';
import { GcpRow } from '../gcp-parser';

function parseGcpRows(rows: GcpRow[]): GcpModel[] {
  return rows
    .filter((x) => x.included)
    .map((x) => {
      return {
        name: x.name.value,
        enu: [x.e.value, x.n.value, x.h.value].map(parseFloat) as [number, number, number],
        status: 'ENABLED',
      };
    });
}

export function convertGcpRowsToGcpCollectionModel(
  fileName: string | undefined | null,
  rows: GcpRow[],
): GcpCollectionModel | undefined | null {
  // Returns null or undefined if the file is not set. null will delete any current collection from the geodata.
  if (!isDefined(fileName)) {
    return fileName;
  }

  // Return undefined for invalid or empty collection which means the geodata will remain unchanged.
  if (fileName.trim().length === 0 || rows.length === 0) {
    return undefined;
  }

  return {
    name: fileName,
    points: parseGcpRows(rows),
  };
}
